import qoalaStorage from '~/core/Storage';
import { parseIfJsonString } from '~/core/helper/JSONHelper';

export default {
  getHcpData: state => {
    return qoalaStorage.getItem('hcpData') ? parseIfJsonString(qoalaStorage.getItem('hcpData')) : state.hcpData;
  },
  getListProduct: state => {
    const listProduct = qoalaStorage.getItem('hcpProduct')
      ? parseIfJsonString(qoalaStorage.getItem('hcpProduct'))
      : state.listProduct;
    return listProduct || [];
  },
  getProductDetail: state => {
    return qoalaStorage.getItem('productDetailHcp')
      ? parseIfJsonString(qoalaStorage.getItem('productDetailHcp'))
      : state.productDetail;
  }
};
